import store from ".."

export default {
  state: {
    menu: {}
  },
  mutations: {
    setMenu(store, value) {
      store.menu = value
    },
    mergeItem(store, item) {
      store.menu.items[item.id] = {...store.menu.items[item.id], ...item}
      store.menu = {...store.menu}      
    }
  },
  actions: {
    async loadMenu({ commit, dispatch }) {
      await commit('setMenu', await dispatch('apiQuery', {method: '/menu'}))
    },
    async displaceMenuitem({ commit, dispatch }, {from_id, to_id}) {
      await commit('setMenu', await dispatch('apiQuery', {method: '/displace_menuitem', body: {from_id, to_id}}))
    },
    async displaceCategory({ commit, dispatch }, {from_id, to_id}) {
      await commit('setMenu', await dispatch('apiQuery', {method: '/displace_category', body: {from_id, to_id}}))
    },
    async updateMenuitem({ commit, dispatch }, body) {
      await commit('mergeItem', await dispatch('apiQuery', {method: '/menu/item', body}))
    }
  },
  getters: {
    menu_categories_map(store) {
      return store.menu.categories || {}
    },
    menu_categories(_, getters) {
      const deliveryCategoryId = store.getters.config.r_keeper_references.categ_dish_delivery;

      let menuCategories = Object.values(getters.menu_categories_map).sort((a, b) => a.sort_order - b.sort_order)

      if (deliveryCategoryId !== 0) {
        menuCategories = menuCategories.filter(category => category.id !== deliveryCategoryId);
      }

      return menuCategories;
    },
    menu_items_map(store) {
      return store.menu.items || {}
    },
    menu_items(_, getters) {
      return Object.values(getters.menu_items_map).sort((a, b) => a.sort_order - b.sort_order)
    },
    menu_modifier_schemes_map(store) {
      return store.menu.modifier_schemes || {}
    },
    menu_merged_items(_, getters) {
      const deliveryCategoryId = store.getters.config.r_keeper_references.categ_dish_delivery;

      let merged = Object.values(getters.menu_categories_map).reduce((prev, cur) => {
        if (cur.id !== deliveryCategoryId) {
          prev[cur.id] = {
            ...cur,
            items: []
          }
        }
        return prev
      }, {})
      

      getters.menu_items.forEach(el => {
        if (el.category_ref !== deliveryCategoryId) {
          merged[el.category_ref].items.push({...el})
        }
      })

      let a = Object.values(merged).sort((a,b) => a.sort_order - b.sort_order)//.map(el => ({...el, items: el.items.sort((a,b) => a.sort_order - b.sort_order)}))

      return a
    }
  }
}